import { render, staticRenderFns } from "./ExtrasForm.vue?vue&type=template&id=60496294&"
import script from "./ExtrasForm.vue?vue&type=script&lang=js&"
export * from "./ExtrasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports